import flatpickr from 'flatpickr';

// Country input field (may be used in many forms)
var countryField = document.getElementById('ramsey-network-form-country-field');

// Financing Notes text field (used in the Debt Free Scream Form)
var financingField = document.getElementById(
  'debt-free-scream-form-financingnotes-field'
);

// Checks the Debt Free Scream form Financing Questions to see if "Yes" was selected for any question.
const anyFinancingCheckedTrue = () =>
  document.getElementById('debt-free-scream-form-financingyes').checked ||
  document.getElementById('debt-free-scream-form-usedretirementyes').checked ||
  document.getElementById('debt-free-scream-form-creditcardyes').checked;

// This handler listens to the "State" input field and, when key "Other" (value "Outside US") is selected, a new field should appear to ask for their country.
const addStateSelectEventListener = (stateSelect, countryInput) => {
  if (stateSelect) {
    stateSelect.addEventListener('change', () => {
      if (stateSelect.value === 'Other') {
        countryField.classList.remove('important-key');
      } else if (!countryField.classList.contains('important-key')) {
        countryField.classList.add('important-key');
        countryInput.value = '';
      }
    });
  }
};

// This handler listens to the Financing radio buttons on the Debt Free Scream form. If "yes" is selected for any of the three questions, a new required field should appear asking them to explain why they answered "yes".
const addFinancingNotesEventListener = (
  financingRadButtons,
  financeNotesInput
) => {
  if (financingRadButtons) {
    for (const rb of financingRadButtons) {
      rb.addEventListener('change', () => {
        if (rb.value === 'true') {
          financingField.classList.remove('important-key');
          financeNotesInput.required = true;
        } else if (
          !financingField.classList.contains('important-key') &&
          !anyFinancingCheckedTrue()
        ) {
          financingField.classList.add('important-key');
          financeNotesInput.value = '';
          financeNotesInput.required = false;
        }
      });
    }
  }
};

const initializeRamseyNetworkForms = () => {
  document.querySelectorAll('.RamseyNetworkForm').forEach((form) => {
    // Find the "select" field that has the name "State"
    const stateSelect = form.querySelector("select[name='State']");
    // Find all of the "radio button" fields that have names like "UsedRetirement", CreditCard" or "Financing"
    const financingRadButtons = form.querySelectorAll(
      "input[name='UsedRetirement'], input[name='CreditCard'], input[name='Financing']"
    );
    // Find the "Country" input field
    const countryInput = form.querySelector("input[name='Country']");
    // Find the "FinancingNotes" textarea
    const financeNotesInput = form.querySelector(
      "textarea[name='FinancingNotes']"
    );

    // Add the event listeners to these fields
    addStateSelectEventListener(stateSelect, countryInput);
    addFinancingNotesEventListener(financingRadButtons, financeNotesInput);
  });
};

// This is our customization for the inputDate macro.
// Make past dates and weekends to be non-selectable.
// Had to set allowInput = true so the field would not be readonly.
flatpickr('.js-datepicker', {
  minDate: 'today',
  dateFormat: 'm/d/Y',
  allowInput: true,
  disable: [
    // Disable weekends
    function (date) {
      // return true to disable
      return date.getDay() === 0 || date.getDay() === 6;
    },
        // Disable specific dates
        "11/23/2023",
        "11/24/2023",
        "12/25/2023",
        "12/26/2023",
        "01/01/2024",
        "03/29/2024",
        "05/27/2024",
        "07/04/2024",
        "07/05/2024",
        "09/02/2024",
        "11/28/2024",
        "11/29/2024",
        "12/23/2024",
        "12/24/2024",
        "12/25/2024",
        "01/01/2025",
  ],
  locale: {
    firstDayOfWeek: 0 // start week on Sunday
  }
});

// This is another customization for the inputDate macro.
// Makes all days selectable.
// Had to set allowInput = true so the field would not be readonly.
flatpickr('.js-datepicker-alldays', {
  dateFormat: 'm/d/Y',
  allowInput: true
});

initializeRamseyNetworkForms();
